export const DEFAULT_ATTRIBUTES = [
  'get-text',
  'i18n',
  'translate',
  'qMessage'
];

export const DEFAULT_DELIMITERS = {
  start: '[#',
  end: '#]',
};

// 留用
// export const ATTRIBUTE_COMMENT = 'comment';
// export const ATTRIBUTE_CONTEXT = 'context';
// export const ATTRIBUTE_PLURAL = 'plural';

export const MARKER_NO_CONTEXT = '__NOCONTEXT__';
